module.exports = __webpack_public_path__ + "img/alabama-power-logo.1a1d7ec1.jpg";